import {cs}        from "./chain-services";
import {fragments} from "./fragments";
import {Invoke}    from "./invoke";
import {keyed}     from "./keyed";
import {scnv}      from "./state-change-nested-value";
import {UseState}  from "./use-state";

/**
 * Cache loaded value
 * @param disabled
 * @param keys active keys
 * @param load accept single key
 * @param next
 * @constructor
 */
export const KeyLoader2 = ({disabled=false, keys, load, next}) => cs(
    ["state", (_, next) => UseState({initValue: {}, next})],
    ({state}) => {
        const loadingKeys = keys?.filter((k) => !state.value[k]) ?? [];
        return fragments(
            next({
                getValue: (key) => state.value[key]?.value,
                isLoading: (key) => disabled ? false : !state.value[key],
                loading: loadingKeys.length,
                changeValue: (key, change) => scnv(state, [key, "value"], change),
            }),

            !disabled && loadingKeys.map((key) => cs(
                keyed(key),
                () => Invoke({
                    action: async () => {
                        const value = await load(key);
                        scnv(state, [key], () => ({value}));
                    },
                }),
            )),
        );
    },
);
